export const regionAttributeNumberKeys = {
    regionExtraVoteLabel: 'region_extra_vote_label',
    regionDescription: 'region_description',
    regionExtraVoteQuantity: 'region_extra_vote_quantity',
    regionNoVoteDescription: 'region_no_vote_description',
};
